module.exports = __webpack_public_path__ + "static/media/webpack.d1e458c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/webpack.png
// module id = 212
// module chunks = 0